
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M15.247 41.08H29.8v5.06H15.247z"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","d":"M20.413 22.516v-.92c0-1.915-1.47-2.885-2.92-2.885-1.86 0-3.368 1.444-3.368 3.437v8.077c0 1.993 1.281 3.61 3.67 3.61v4.602m2.734-12.14a2.11 2.11 0 0 1-1.913 1.186c-1.162 0-2.104-.913-2.104-2.04V22.86m5.575-15.524c0-1.48-1.181-2.68-2.64-2.68-1.457 0-2.639 1.2-2.639 2.68v11.071m10.675-1.87V4.315a2.69 2.69 0 0 0-2.698-2.68 2.69 2.69 0 0 0-2.698 2.68v12.223m5.396-9.202c0-1.48 1.183-2.68 2.643-2.68s2.643 1.2 2.643 2.68l.008 22.89c0 1.993-1.658 3.61-3.704 3.61h-.412m-.119-6.825h-6.174c-1.56 0-2.823-1.23-2.823-2.75 0-1.518 1.264-2.749 2.823-2.749h7.158c1.796 0 3.252 1.694 3.252 3.782m-9.17 5.627c0-2.16 1.796-3.91 4.013-3.91m3.032 6.396v5.063M16.343 38h15.813v6.375H16.344z"}})])
          )
        }
      }
    